export const friendCenterAssets = {
	common: {
		confirmPopupBackground: "/spec_friend_center/confirm-popup-bg.jpg",
		confirmPopupBackgroundLandscape:
			"/spec_friend_center/confirm-popup-bg-landscape.png",
		mainBanner: "/spec_friend_center/main-banner.jpg",
		noFriends: "/spec_friend_center/no-friends.png",
		profileMock: "/spec_friend_center/profile-mock.png"
	},
	friendShop: {
		collectPopupBackground:
			"/spec_friend_center/friend_shop/collect-popup-bg.jpg",
		infoPopupBackgroundLandscape:
			"/spec_friend_center/friend_shop/info-popup-bg-landscape.jpg",
		priceBadge: "/spec_friend_center/friend_shop/priceBadge.svg",
		steps: {
			step1: "/spec_friend_center/friend_shop/step1.jpg",
			step2: "/spec_friend_center/friend_shop/step2.jpg",
			step3: "/spec_friend_center/friend_shop/step3.jpg"
		}
	},
	friendInvite: {
		background: "/spec_friend_center/friend_invite/invite-bg.png",
		backgroundLarge: "/spec_friend_center/friend_invite/invite-bg-large.png",
		checkmark: "/spec_friend_center/friend_invite/checkmark.svg",
		noFriendsState: "/spec_friend_center/friend_invite/no-friends-state.png",
		popupBackgroundLandscape:
			"/spec_friend_center/friend_invite/popup-bg-landscape.jpg",
		steps: {
			step1: "/spec_friend_center/friend_invite/step1.jpg",
			step2: "/spec_friend_center/friend_invite/step2.jpg",
			step3: "/spec_friend_center/friend_invite/step3.jpg"
		},
		userBarPlaceholder:
			"/spec_friend_center/friend_invite/user-bar-placeholder.png"
	}
} as const;
